var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"type":_vm.$route.matched[0] ? _vm.$route.matched[0].props.default.type : 'is-primary'}}),_c('router-view'),_c('Footer',{attrs:{"type":_vm.$route.matched[0] ? _vm.$route.matched[0].props.default.type : 'is-primary'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }